/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useContext, useRef } from "react";
import context from "../../../../../../context/auth-context";
import { API_BASE_URL } from "../../../../../../constants";
import { connect, useSelector } from "react-redux";
import LanguageDrawer from "../Drawer/LanguageDrawer";
import classnames from "classnames";
import { useDispatch } from "react-redux";

// const flagCodes = [
//   'ad', 'ae', 'af', 'ag', 'ai',
//   'al', 'am', 'ao', 'aq', 'ar',
//   'as', 'at', 'au', 'aw', 'ax',
//   'az', 'ba', 'bb', 'bd', 'be',
//   'bf', 'bg', 'bh', 'bi', 'bj',
//   'bj', 'bl', 'bm', 'bn', 'bo',
//   'bq', 'br', 'bs', 'bt', 'bv',
//   'bw', 'by', 'bz', 'ca', 'cc',
//   'cd', 'cf', 'cg', 'ch', 'ci', 'ck',
//   'cl', 'cm', 'cn', 'co', 'cr', 'cu',
//   'cv', 'cw', 'cx', 'cy', 'cz', 'de',
//   'dj', 'dk', 'dm', 'do', 'dz', 'ec',
//   'ee', 'eg', 'eh', 'er', 'es', 'et',
//   'fi', 'fj', 'fk', 'fm', 'fo', 'fr',
//   'ga', 'gb', 'gd', 'ge', 'gf', 'gg',
//   'gh', 'gi', 'gl', 'gm', 'gn', 'gp',
//   'gq', 'gr', 'gs', 'gu', 'gw', 'gy',
//   'hk', 'hm', 'hn', 'hr', 'ht', 'hu',
//   'id', 'ie', 'il', 'im', 'in', 'io',
//   'iq', 'ir', 'is', 'it', 'je', 'jm',
//   'jo', 'jp', 'ke', 'kg', 'kh', 'ki',
//   'km', 'kn', 'kp', 'kr', 'kw', 'ky',
//   'kz', 'la', 'lb', 'lc', 'li', 'lk',
//   'lr', 'ls', 'lt', 'lu', 'lv', 'ly',
//   'ma', 'mc', 'md', 'me', 'mf', 'mg',
//   'mh', 'mk', 'ml', 'mm', 'mn', 'mo',
//   'mp', 'mq', 'mr', 'ms', 'mt', 'mu',
//   'mv', 'mw', 'mx', 'my', 'mz', 'na',
//   'nc', 'ne', 'nf', 'ng', 'ni', 'nl',
//   'no', 'np', 'nr', 'nu', 'nz', 'om',
//   'pa', 'pe', 'pf', 'pg', 'ph', 'pk',
//   'pl', 'pm', 'pn', 'pr', 'ps', 'pt',
//   'pw', 'py', 'qa', 're', 'ro', 'rs',
//   'ru', 'rw', 'sa', 'sb', 'sc', 'sd',
//   'se', 'sg', 'sh', 'si', 'sj', 'sk',
//   'sl', 'sm', 'sn', 'so', 'sr', 'ss',
//   'st', 'sv', 'sx', 'sy', 'sz', 'tc',
//   'td', 'tf', 'tg', 'th', 'tj', 'tk',
//   'tl', 'tm', 'tn', 'to', 'tr', 'tt',
//   'tv', 'tw', 'tz', 'ua', 'ug', 'um',
//   'us', 'uy', 'uz', 'va', 'vc', 've',
//   'vg', 'vi', 'vn', 'vu', 'wf', 'ws',
//   'ye', 'yt', 'za', 'zm', 'zw'
// ]

const languageToCountry = (code) => {
  switch (code) {
    case "en":
      return "gb";
    case "fr":
      return "fr";
    case "sw":
      return "ke";
    case "ab":
      return "ge";
    case "aa":
      return "et";
    case "af":
      return "za";
    case "sq":
      return "al";
    case "an":
      return "eu";
    case "hy":
      return "am";
    case "as":
      return "in";
    case "ay":
      return "pe";
    case "az":
      return "az";
    case "ba":
      return "kz";
    case "eu":
      return "eu";
    case "bn":
      return "in";
    case "dz":
      return "in";
    case "bh":
      return "in";
    case "bi":
      return "vu";
    case "am":
      return "et";
    // case '':
    //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    // // case '':
    // //   return '';
    default:
      return null;
  }
};

const Languages = (props) => {
  const authContext = useContext(context);
  const { companyLanguages, activeLanguage } = useSelector(
    (state) => state.languages
  );
  const isOpen = useSelector((state) => state.drawer.isOpen);
  const { setSystemLanguage, setCompanyLanguage, openLanguageDrawer } = props;
  const dispatch = useDispatch();
  const flagRef = useRef(null);

  const setActiveLanguage = (language) => {
    dispatch({ type: "SET_ACTIVE_LANGUAGES", payload: language });
  };

  useEffect(() => {
    if (authContext.companyId !== null) {
      fetch(`${API_BASE_URL}/companies/${authContext.companyId}/languages`, {
        method: "GET",
        headers: {
          "Company-Code": authContext.companyCode,
          "Company-Id": authContext.companyId.toString(),
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCompanyLanguage(data);
          const indexOfDefault = data.findIndex(
            (language) => language.is_default === "Y"
          );
          if (indexOfDefault > -1)
            dispatch({
              type: "SET_ACTIVE_LANGUAGES",
              payload: data[indexOfDefault],
            });
          return data;
        })
        .catch((err) => console.log("ERROR"));
    }
  }, [authContext, setCompanyLanguage, isOpen, dispatch]);
  useEffect(() => {
    fetch(`${API_BASE_URL}/utilities/languages`, {
      method: "GET",
      headers: {
        "Company-Code": authContext.companyCode,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSystemLanguage(data);
        return data;
      })
      .catch((err) => console.log("ERROR"));
  }, [authContext, setSystemLanguage]);

  return (
    <li className="nav-item dropdown">
      <a
        className="nav-link"
        data-toggle="dropdown"
        data-animation="scale-up"
        aria-expanded="false"
        role="button"
        style={{ cursor: "pointer" }}
      >
        {activeLanguage ? (
          languageToCountry(activeLanguage.code) ? (
            <span
              ref={flagRef}
              className={`flag-icon flag-icon-${languageToCountry(
                activeLanguage.code
              )}`}
            >
              {""}
            </span>
          ) : (
            <span>
              {activeLanguage.name?.toUpperCase()[0] +
                activeLanguage.name?.toUpperCase()[1]}
            </span>
          )
        ) : (
          <i
            className="icon fa-language"
            ref={flagRef}
            aria-hidden="true"
            style={{ fontSize: 20 }}
          ></i>
        )}
      </a>
      <div
        className="dropdown-menu dropdown-menu-media"
        role="menu"
        style={{ width: 250 }}
      >
        <div className="dropdown-menu-header text-center">
          <h5>COMPANY LANGUAGES</h5>
        </div>

        <div className="list-group">
          <div data-role="container">
            <div data-role="content">
              {companyLanguages.languages != null ? (
                companyLanguages.languages.language.map((language) => {
                  return (
                    <a
                      key={language.code}
                      style={{ fontWeight: 400, cursor: "pointer" }}
                      className={classnames("dropdown-item", {
                        active:
                          activeLanguage && language.id === activeLanguage.id,
                      })}
                      role="menuitem"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveLanguage(language);
                      }}
                    >
                      {language.code ? (
                        languageToCountry(language.code) ? (
                          <span
                            ref={flagRef}
                            className={`flag-icon flag-icon-${languageToCountry(
                              language.code
                            )}`}
                          ></span>
                        ) : (
                          <i
                            className="icon fa-language"
                            ref={flagRef}
                            aria-hidden="true"
                            style={{ fontSize: 17 }}
                          ></i>
                        )
                      ) : (
                        <i
                          className="icon fa-language"
                          ref={flagRef}
                          aria-hidden="true"
                          style={{ fontSize: 17 }}
                        ></i>
                      )}
                      {language.is_default === "Y"
                        ? language.name + " (Default)"
                        : language.name}
                    </a>
                  );
                })
              ) : (
                <span>No Languages found</span>
              )}
            </div>
          </div>
        </div>
        <div
          className="dropdown-menu-footer"
          onClick={() => authContext.isICT !== "Y" && openLanguageDrawer(true)}
        >
          <a
            onClick={() =>
              authContext.isICT !== "Y" && openLanguageDrawer(true)
            }
            className="dropdown-item text-center"
            role="menuitem"
            style={{ cursor: "pointer", fontWeight: 600 }}
          >
            Update Languages
          </a>
        </div>
      </div>
      {isOpen != null ? <LanguageDrawer open={isOpen.open} /> : <></>}
    </li>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCompanyLanguage: (language) =>
      dispatch({ type: "SET_COMPANY_LANGUAGES", payload: { language } }),
    setSystemLanguage: (language) =>
      dispatch({ type: "SET_SYSTEM_LANGUAGES", payload: { language } }),
    openLanguageDrawer: (open) =>
      dispatch({ type: "OPEN_LANGUAGE_DRAWER", payload: { open } }),
  };
};

export default connect(null, mapDispatchToProps)(Languages);
